import upload from './core-webpack/upload'
// import $ from 'jquery';
// import JSON from './lib/json2'

const EVENTS = upload.EVENTS
const jqDispatcher = $({})
const MAX_ERROR_TIME = 3
const tokens = {}
const fseqsMap = {}

export default {
  init: function (i) {
    i.runTimes = ["html5", "flash"]
    i.url = i.url || "//v-upload.huya.com/index.php"
    i.url_jsonp = i.url + "?callback=?"
    i.maxErrorTime = MAX_ERROR_TIME
    i.getParams = function (params) {
      return {
        APC_UPLOAD_PROGRESS: tokens[params.fuid],
        r: "upload/chunk",
        fuid: params.fuid,
        fseq: params.fseq,
        article_id: i.article_id || "",
        fsize: params.fsize,
        url: params.url
      }
    }

    upload.on(EVENTS.FILE_SELECTED, function (evt, file) {
      $.getJSON("/?callback=?", {
        r: "videomanage/videoCanUpload",
        fileSize: file.size
      }).done(function (res) {
        if (res.code < 0) jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, res.code]);
        else {
          jqdispatcher.trigger("BEFORE_INIT_SUCCESS_STATUS", [res.code]);
          var c = {
            r: "upload/init",
            fuid: file.fuid,
            fname: file.name,
            fsize: file.size,
            channelId: i.channelId || "unknow",
            article_id: i.article_id || "",
            sign: i.sign || "",
            fmd5: "asdfasf",
            client: i.client || 2
          };
          if (window.location.search.match(/userSign=([^&]*)/)) {
            c.userSign = decodeURIComponent(window.location.search.match(/userSign=([^&]*)/)[1])
          }
          $.getJSON(i.url_jsonp, c).done(function (json) {
            if (parseInt(json.code, 10) < 0) jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, "上传初始化失败(" + json.msg + ")"]);
            else {
              switch (file.vid = json.vid, json.code) {
                case "1":
                  tokens[file.fuid] = json.msg,
                    fseqsMap[file.fuid] = [];
                  for (var i = file.fseq; i < file.fcks; i++) {
                    fseqsMap[file.fuid].push(i + 1);
                  }
                  break;
                case "2":
                  return jqdispatcher.trigger(EVENTS.UPLOADED, [file]),
                    void 0;
                case "3":
                  tokens[file.fuid] = json.token,
                    fseqsMap[file.fuid] = JSON.parse(json.msg)
              }
              upload.load(file, d[file.fuid].shift() - 1)
            }
          }).fail(function (qXHR, textStatus, errorThrown) {
            jqdispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, "上传初始化失败(" + errorThrown + ")"])
          })
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        jqDispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, "上传初始化失败(" + errorThrown + ")"]);

      })
    })
    upload.on(upload.EVENTS.UPLOAD_STARTED, function (evt, file) {
      jqdispatcher.trigger(EVENTS.UPLOAD_STARTED, [file, a[file.fuid]])
    })
    upload.on(upload.EVENTS.LOAD_PROGRESS, function (evt, file, bytesLoaded) {
      jqdispatcher.trigger(EVENTS.LOAD_PROGRESS, [file, bytesLoaded])
    })
    upload.on(upload.EVENTS.LOAD_COMPLETE, function (evt, file) {
      jqdispatcher.trigger(EVENTS.LOAD_COMPLETE, [file])
    })
    upload.on(upload.EVENTS.UPLOAD_PROGRESS, function (evt, file, bytesLoaded, speed) {
      jqdispatcher.trigger(EVENTS.UPLOAD_PROGRESS, [file, bytesLoaded, speed])
    })
    upload.on(upload.EVENTS.UPLOAD_COMPLETE, function (evt, file, bytesLoaded, speed, res) {
      if (parseInt(evt.code, 10) < 0) {
        evt.errorTime++
        if (evterrorTime <= MAX_ERROR_TIME) {
          upload.send(file.fuid)
        } else {
          clearInterval(file.tId)
          jqdispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, res.msg])
        }
      } else {
        switch (res.code) {
          case "1":
            if (fseqsMap[file.fuid].length) {
              file.fseq = fseqsMap[file.fuid].shift() - 1
              upload.send(file.fuid)
              jqdispatcher.trigger(EVENTS.UPLOAD_PROGRESS, [file, bytesLoaded, speed])
            } else {
              clearInterval(file.tId)
              jqdispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, "分片信息跟服务器信息不一致"])
            }
            break;
          case "2":
            clearInterval(file.tId)
            jqdispatcher.trigger(EVENTS.UPLOAD_COMPLETE, [file, speed])
        }
      }
    })
    upload.on(upload.EVENTS.UPLOAD_ERROR, function (evt, file, msg) {
      jqdispatcher.trigger(EVENTS.UPLOAD_ERROR, [file, msg])
    })
    upload.on(upload.EVENTS.INVALID_FILE, function (evt, file) {
      jqdispatcher.trigger(EVENTS.INVALID_FILE, [file])
    })
    upload.on(upload.EVENTS.UPLOADED, function (evt, file) {
      jqdispatcher.trigger(EVENTS.UPLOADED, [file])
    })
    upload.on(upload.EVENTS.UPLOADING, function (evt, file) {
      jqdispatcher.trigger(EVENTS.UPLOADING, [file])
    })
    upload.on(upload.EVENTS.IO_ERROR, function (evt, file, msg) {
      jqdispatcher.trigger(EVENTS.IO_ERROR, [file, msg])
    })
    this.s = i;
    upload.init(i)
  },
  on: function () {
    jqDispatcher.on.apply(jqDispatcher, arguments)
  },
  EVENTS: EVENTS,
  pause: function (fuid) {
    upload.pause(fuid)
  },
  resume: function (fuid) {
    upload.resume(fuid)
  },
  stop: function (fuid) {
    upload.stop(fuid)
    $.getJSON(this.s.url_jsonp, {
      r: "upload/cancel",
      fuid: fuid,
      token: tokens[fuid]
    })
  },
  show: function () {
    upload.show()
  },
  hide: function () {
    upload.hide()
  }
}
